import React from 'react'
import { Row, Col, Container, Button, ButtonToolbar, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import ProductsList from './Products/ProductsList';
import { useStateValue } from '../../utilities/StateProvider';

export default function StepFour(props) {

    const [{ isInterior }, dispatch] = useStateValue();

    const handleChangeInterior = (value) => {
        dispatch({
            type: 'setInterior',
            isInterior: value
        });
    }

    return (
        <Container>
            <Row>
                <Col className="step-header">
                    <div className="title">Añádele extras a tu Show</div>
                </Col>
            </Row>
            <Row>
                <ButtonToolbar className="price-toggle">
                    <ToggleButtonGroup name="price-toggle" value={isInterior} onChange={handleChangeInterior}>
                        <ToggleButton value={false} className="toggle-button">Caracas</ToggleButton>
                        <div className="price-toggle-divisor"/>
                        <ToggleButton value={true} className="toggle-button">Otros Estados</ToggleButton>
                    </ToggleButtonGroup>
                </ButtonToolbar>
            </Row>
            <Row>
                <ProductsList type="extras" />
            </Row>
            <Button className="shop-button" onClick={props.prev}>Atrás</Button>
            <Button className="shop-button" onClick={props.next}>Siguiente</Button>
        </Container>
    )
}
